// removed by extract-text-webpack-plugin
module.exports = {"hidden":"_1ulfP","visuallyhidden":"_34NOs","hide-text":"pk_7H","center":"_3j9Ra","noprint":"x3DXX","buttonsWrapper":"gQ2ll"};


/*****************
 ** WEBPACK FOOTER
 ** ./~/@vg/cn-skin-vg/styles/components/MastheadExtensionSubscriptionButtons.scss
 ** module id = 967
 ** module chunks = 1
 **/